import { render, staticRenderFns } from "./CurveSetting.vue?vue&type=template&id=9327a620&scoped=true"
import script from "./CurveSetting.vue?vue&type=script&lang=js"
export * from "./CurveSetting.vue?vue&type=script&lang=js"
import style0 from "./CurveSetting.vue?vue&type=style&index=0&id=9327a620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9327a620",
  null
  
)

export default component.exports